import { render, staticRenderFns } from "./MenuCurrency.vue?vue&type=template&id=2e4bdb53&"
import script from "./MenuCurrency.vue?vue&type=script&lang=js&"
export * from "./MenuCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports